var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotateFrameActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2887 4.79169H6.9554C6.07135 4.79169 5.2235 5.14288 4.59838 5.768C3.97326 6.39312 3.62207 7.24097 3.62207 8.12502V8.95835",
    stroke: "#21A6AA",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20508 2.70831L10.2884 4.79165L8.20508 6.87498",
    stroke: "#21A6AA",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9551 9.79169H10.2884C10.0674 9.79169 9.85544 9.87948 9.69916 10.0358C9.54287 10.192 9.45508 10.404 9.45508 10.625V17.2917",
    stroke: "#21A6AA",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.78809 15.625H14.4548C14.6758 15.625 14.8877 15.5372 15.044 15.3809C15.2003 15.2246 15.2881 15.0127 15.2881 14.7917V8.125",
    stroke: "#21A6AA",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateFrameActive);
export default __webpack_public_path__ + "static/media/rotate-frame-active.200ede7306e7f443a8cd5696d7d60291.svg";
export { ForwardRef as ReactComponent };